const canHover = '@media (hover: hover) and (pointer: fine)';
const canTouch = '@media (hover: none) and (pointer: coarse)';

export { canHover, canTouch };
